<vtabela ng-if="!!bds.vtabela" id="relatorio-bdv" grid-options="bds.vtabela" analytics-category="Relatorios" analytics-label="BDS"></vtabela>